/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable()
export class CountersApi {
  private readonly apiController: string = 'counters';

  constructor(private api: HttpService) { }

  getData(params: any): Observable<any> {
    const now = new Date();
    const json = `{"location":
                  {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
                  "device":{"sn":"${params.sn}"},
                  "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate() - 1}},
                  "filter":{"orderBy":"ASC"}}`;
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/byDate`, data);
  }

  getStat(params: any): Observable<any> {
    const now = new Date();
    const json = `{"location":
                  {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
                  "device":{"sn":"${params.sn}"},
                  "date1":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":1},
                  "date2":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
                  "filter":{"orderBy":"ASC"}}`;
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/stat`, data);
  }

  list(): Observable<any[]> {
    return this.api.get(this.apiController);
  }
}
